import { Injectable } from '@angular/core';
import { Model } from 'survey-core';
import {
  ApplicationsApiService,
  SnackbarService,
  ProductTypeCatalogApiService,
  OfficesApiService,
  CategoriesApiService,
  PeopleApiService,
  PeopleLookupApiService,
  CoursesApiService,
  CoursesOnDemandApiService
} from '@tangilla/tg-ng-core';
import { SurveyUtilsService } from '../utils/survey.utils.service';
import { SurveyService } from 'src/app/core/services/survey/survey.service';
import { ApplicationForm } from '../utils/application-form';
import { ErrorsService } from 'src/app/core/services/utils/errors.service';
import { DetailsListWidgetService } from '../../widgets/details-list/services/details-list.widget.service';
import {
  ApplicationChargesUtilsService
} from '../../../../core/services/utils/charges/application-charges.utils.service';

@Injectable({
  providedIn: 'root'
})
export class StaffApplicationService extends ApplicationForm {

  constructor(
    protected categoriesApiService: CategoriesApiService,
    override officesApiService: OfficesApiService,
    override applicationsService: ApplicationsApiService,
    override snackbarService: SnackbarService,
    override productTypeCatalogService: ProductTypeCatalogApiService,
    override chargesUtils: SurveyUtilsService,
    override surveyService: SurveyService,
    override peopleApiService: PeopleApiService,
    override peopleLookupService: PeopleLookupApiService,
    override errorsService: ErrorsService,
    override detailsListWidgetService: DetailsListWidgetService,
    override applicationChargesUtilsService: ApplicationChargesUtilsService,
    override coursesOnDemandApiService: CoursesOnDemandApiService,
    override coursesApiService: CoursesApiService
  ) {
    super(applicationsService, productTypeCatalogService, snackbarService, chargesUtils, surveyService, peopleApiService, peopleLookupService, errorsService, officesApiService, detailsListWidgetService, applicationChargesUtilsService, coursesOnDemandApiService, coursesApiService);
  }

  override initializeForm(): any {
    this.formatter = new Intl.NumberFormat('en-US', {
      style: 'currency',
      currency: 'USD',
    });

    const staffRole = this.surveyService.surveyModel.getVariable('staff_form_role_code') || 'AXX';
    this.surveyService.surveyModel.setValue('role', staffRole);
    this.surveyService.surveyModel.setValue('association_product_type', staffRole);
    this.surveyService.surveyModel.setValue('MembershipType', 'Staff');
    this.surveyService.surveyModel.setValue('office', this.surveyService.surveyModel.getVariable('v-staff-office'));
    this.surveyService.surveyModel.setValue('primary_field_of_business', '302'); // General Real Estate

    /*if(!clear_fwd_answers){
      console.warn('clear_fwd_answers not enabled');
    }*/

    this.setFormOnComplete();

    // Here goes the navigation code for the membership application form
    this.initializeOnAfterRenderPage();
    this.initializeOnCurrentPageChanging();
    this.initializeOnValueChanged();

  }

  override setFormOnComplete() {
    const that = this;

    this.surveyService.surveyModel.onComplete.add(function (result) {
    });
  }

  override initializeOnAfterRenderPage() {
    this.surveyService.surveyModel.onAfterRenderPage.add((sender, options) => {
      const currentPage = sender.currentPage;
      switch (currentPage.name) {
        case 'Type Of Membership':
          this.getProductCatalogForRole().subscribe();
      }
    });
  }

  override initializeOnCurrentPageChanging() {
    this.surveyService.surveyModel.onCurrentPageChanging.add((sender, options) => {
      if (options.oldCurrentPage !== null) {
        const thisPageName = options.oldCurrentPage.name;
        switch (thisPageName) {
        }

      }
    });
  }

  override initializeOnValueChanged() {
    this.surveyService.surveyModel.onValueChanged.add((sender, options) => {
    });
  }

  setFormOnCompleting(surveyModel: Model) {
    surveyModel.onCompleting.add(async function (survey, options) {
    });
  }


}
